import React from "react";
import { NavLink } from "react-router-dom";

const Link = ({ href, label, onClose, Icon }) =>  {
    return (
        <NavLink
            to={href}
            onClick={onClose}
            className={({ isActive }) => `
                group flex flex-col items-center min-h-10 transition-colors duration-300 ease-in-out
                ${isActive ? " text-rs-azul bg-gray-200" : "text-white hover:bg-gray-500"}
                py-1 md:rounded-l-xl text-sm text-center`}
        >
            {({ isActive }) => (
                <>
                    {Icon && (
                        <Icon
                            className={`transition-transform duration-300 group-hover:scale-110 mx-auto ${
                                isActive ? "text-rs-azul animate-bouncing" : "text-white"
                            }`}
                            size={25}
                        />
                    )}
                    {label}
                </>
            )}
        </NavLink>
    )
};

export default Link;